import React from 'react';
import { Line, Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

interface ChartData {
  name: string;
  value: number;
}

interface ChartProps {
  data?: ChartData[];
}

export const LineChart: React.FC<ChartProps> = ({ data }) => {
  const chartData = {
    labels: data ? data.map(d => d.name) : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Data',
        data: data ? data.map(d => d.value) : [1200, 1900, 3000, 5000, 2000, 3000],
        borderColor: 'rgb(75, 192, 192)',
        tension: 0.1,
      },
    ],
  };

  return <Line data={chartData} />;
};

export const BarChart: React.FC<ChartProps> = ({ data }) => {
  const chartData = {
    labels: data ? data.map(d => d.name) : ['Event 1', 'Event 2', 'Event 3', 'Event 4', 'Event 5'],
    datasets: [
      {
        label: 'Data',
        data: data ? data.map(d => d.value) : [65, 59, 80, 81, 56],
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
      },
    ],
  };

  return <Bar data={chartData} />;
};

export const PieChart: React.FC<ChartProps> = ({ data }) => {
  const chartData = {
    labels: data ? data.map(d => d.name) : ['18-24', '25-34', '35-44', '45-54', '55+'],
    datasets: [
      {
        data: data ? data.map(d => d.value) : [12, 19, 3, 5, 2],
        backgroundColor: [
          'rgba(255, 99, 132, 0.5)',
          'rgba(54, 162, 235, 0.5)',
          'rgba(255, 206, 86, 0.5)',
          'rgba(75, 192, 192, 0.5)',
          'rgba(153, 102, 255, 0.5)',
        ],
      },
    ],
  };

  return <Pie data={chartData} />;
}; 